import Input from '../core/Input';
import {
  useController,
  UseControllerProps,
  FieldValues,
  FieldError,
} from 'react-hook-form';
import { useIntl } from 'react-intl';
import { cn } from '@/helpers/classnames';

interface Props<T extends FieldValues> extends UseControllerProps<T> {
  className?: string;
  label?: string;
  editMode?: boolean;
  error?: FieldError;
  min?: number;
  max?: number;
  'aria-describedby'?: string;
}

export const InputNumber = <T extends FieldValues>({
  editMode,
  className,
  label,
  error,
  min,
  max,
  'aria-describedby': ariaDescribedBy,
  ...props
}: Props<T>) => {
  const { field } = useController(props);
  const { formatMessage } = useIntl();

  const errorMessage = error
    ? error.message || formatMessage({ defaultMessage: 'Ogiltigt värde' })
    : undefined;

  return editMode ? (
    <Input
      id={field.name}
      type="number"
      value={Number(field.value) || 0}
      className={className}
      label={label}
      onChange={(e) => field.onChange(Number(e.target.value))}
      error={errorMessage}
      inputMode="numeric"
      onBlur={() => field.onBlur()}
      min={min}
      max={max}
      aria-describedby={ariaDescribedBy}
    />
  ) : (
    <span
      className={cn(
        field.value === undefined && 'italic text-text-700',
        className,
      )}
      aria-describedby={ariaDescribedBy}
    >
      {field.value ?? formatMessage({ defaultMessage: 'Inget värde' })}
    </span>
  );
};
